import { Component, OnInit } from '@angular/core';
import { CartService } from 'src/app/services/cart.service';
import { CartItem } from 'src/app/entities/cart-item';
import { Product } from 'src/app/entities/product';
import { TransactionService } from 'src/app/services/transaction.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '@mobileia/authentication';
import { AlertService } from 'src/app/services/alert.service';
import { MetatagService } from 'src/app/services/metatag.service';
import { slugify } from 'src/app/utils/string.utils';

declare var feather: any;

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {

  cart = new Array<CartItem>();
  itemNoStock = new CartItem();
  isLoading = true;
  cartTotal = 0;
  cartSubtotal = 0;
  cartDiscount = 0;
  cartAdditional = 0;
  isSending = false;
  isLogged = false;
  minEnabled = true;
  stockAvailable = true;

  constructor(
    protected cartService: CartService,
    protected transactionService: TransactionService,
    protected navigator: Router,
    protected authService: AuthenticationService,
    protected alertService: AlertService,
    protected metatagService: MetatagService
  ) { }

  ngOnInit() {
    this.metatagService.configSlug('cart');
    // Verificar si el usuario esta logueado
    this.authService.isLoggedIn.subscribe(data => {
      this.isLogged = data;
    });
    this.loadCart();
    this.configDelivery();
    
    // Initialize Feather icons
    setTimeout(() => {
      if (typeof feather !== 'undefined') {
        feather.replace();
      }
    }, 0);
  }

  onClickBuy() {
    // Verificar si esta logueado
    this.stockAvailable = true;
    if (!this.isLogged) {
      this.alertService.showError('Error!', 'Usted debe ingresar a su cuenta para poder comprar.');
      return;
    }


    if (this.isSending) {
      return;
    }

    //chequeo el stock para cada producto antes de proceder
    this.cart.forEach(element => {
      if(this.getStock(element.product) < element.quantity){
        this.stockAvailable = false;
        this.itemNoStock = element;
      }
    });

    if (!this.stockAvailable){
      this.alertService.showError('Error!', 'No hay stock disponible del producto '  + this.itemNoStock.product.title+ ' , lo sentimos.');
      return;
    }

    this.isSending = true;
    this.transactionService.generate(this.cartService.fingerprintCurrent).toPromise().then(data => {
      this.isSending = false;
      if (!data.success) {
        // Check if it's an authentication error
        if (data.error && data.error.code === -2) {
          this.alertService.showError('Sesión expirada', 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.').then(() => {
            // Logout and redirect to login after user closes the alert
            this.authService.signOut();
            //reload to refresh the state
            const window = (globalThis as any).window;
            window.location.reload();
          });
        } else {
          this.alertService.showError('Error!', data.error?.message || 'Ocurrió un error al procesar la solicitud');
        }
        return;
      }
      this.transactionService.transactionCurrent = data.response;
      this.navigator.navigateByUrl('/checkout');
    });
  }

  sumQuantity(item: CartItem) {
    if(this.getStock(item.product) <= item.quantity){
      return;
    }

    this.cartService.sumQuantity(item).toPromise().then(data => {
      if (!data.success) {
        this.alertService.showError('Error', data.error.message);
        return;
      }
    });
  }

  minQuantity(item: CartItem) {
    if (item.quantity == 1) {
      return;
    }
    this.minEnabled = false;

    this.cartService.minQuantity(item).toPromise().then(data => {
      if (!data.success) {
        this.alertService.showError('Error', data.error.message);
        return;
      }
      this.minEnabled = true;
    });
  }

  removeItem(item: CartItem) {
    this.cartService.removeItem(item).toPromise().then(data => {
      if (!data.success) {
        this.alertService.showError('Error', data.error.message);
        return;
      }
    });
  }

  getTotal() {
    this.cartTotal = 0;
    this.cartSubtotal = 0;
    this.cartDiscount = 0;
    
    for (const item of this.cart) {
      const priceWithDiscount = this.getPrice(item.product) * item.quantity;
      const priceWithoutDiscount = this.getPriceWithoutDiscount(item.product) * item.quantity;
      
      this.cartTotal += priceWithDiscount;
      this.cartSubtotal += priceWithoutDiscount;
    }
    
    this.cartDiscount = this.cartSubtotal - this.cartTotal;
    this.cartTotal += this.cartAdditional;
  }

  getPrice(item: Product) {
    return Product.getPrice(item);
  }

  getPriceWithoutDiscount(item: Product) {
    return Product.getPriceWithoutDiscount(item);
  }

  getDiscount(item: Product) {
    return Product.getDiscount(item);
  }

  getStock(item: Product) {
    return Product.getStock(item);
  }

  configDelivery() {
    this.transactionService.currentDelivery.subscribe(data => {
      if (data) {
        this.cartAdditional = data.price;
      } else {
        this.cartAdditional = 0;
      }
    });
  }

  loadCart() {
    this.isLoading = true;
    
    // Subscribe to cart changes FIRST
    this.cartService.items.subscribe(data => {
      this.cart = data;
      this.getTotal();
      // Refresh icons when cart updates
      setTimeout(() => {
        if (typeof feather !== 'undefined') {
          feather.replace();
        }
      }, 100);
    });
    
    // Wait for fingerprint to load from localStorage, then fetch cart
    this.cartService.loadFingerprint().subscribe(() => {
      // Now fingerprint is loaded, fetch the cart
      this.cartService.fetchList().subscribe(fetchResponse => {
        this.isLoading = false;
        // Refresh icons after loading
        setTimeout(() => {
          if (typeof feather !== 'undefined') {
            feather.replace();
          }
        }, 100);
      });
    });
  }

  processProductTitle(product) {
    return slugify(product.title);
  }

}
